import styled from 'styled-components';

export const TaxonHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: column;
    margin-bottom: 20px;
  }
`;

export const TaxonTitle = styled.div`
  font-size: 1.5rem;
  font-weight: 500;
  margin: 10px 0px;
  width: 50%;
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
    font-size: 1.5rem;
  }
`;

export const TaxonControls = styled.div`
  display: flex;
  width: 30%;
  align-items: center;
  justify-content: right;
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
  }
`;

export const ProductCount = styled.div`
  font-size: 0.9rem;
  font-weight: 400;

  width: 70%;
`;
